import { FormProvider, UseFormReturn } from "react-hook-form";
import SubmitCard from "./comm-generator/SubmitCard";
import { DevTool } from "@hookform/devtools";
import React, { useEffect, useRef, useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { useTranslation } from "react-i18next";
function AppFormContainer({
  children,
  form,
  onSubmit,
  isSuccess = false,
  isPending = false,
  savePreferences,
}: {
  children?: React.ReactNode;
  form: UseFormReturn<any>;
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  isSuccess: boolean;
  isPending: boolean;
  savePreferences?: {
    enabled: boolean;
    onToggle: (enabled: boolean) => void;
  };
}) {
  const { t } = useTranslation("common");
  return (
    <>
      <FormProvider {...form}>
        <form onSubmit={onSubmit} className="flex flex-col h-full max-h-full">
          {(() => {
            const submitRef = useRef<HTMLDivElement | null>(null);
            const [_submitHeight, setSubmitHeight] = useState(0);

            useEffect(() => {
              if (!submitRef.current) return;
              const el = submitRef.current;
              const update = () =>
                setSubmitHeight(el.getBoundingClientRect().height);
              update();
              const ro = new ResizeObserver(() => update());
              ro.observe(el);
              window.addEventListener("resize", update);
              return () => {
                ro.disconnect();
                window.removeEventListener("resize", update);
              };
            }, []);

            return (
              <div className="relative flex flex-col flex-1">
                <div className="flex flex-1 flex-col gap-4 px-3 @md:px-9 overflow-y-auto pb-12">
                  {children}

                  {/* Save preferences checkbox - at bottom of form */}
                  {savePreferences && (
                    <div className="flex items-center space-x-2 pt-2">
                      <Checkbox
                        id="save-preferences"
                        className="w-4 h-4"
                        checked={savePreferences.enabled}
                        onCheckedChange={(checked) =>
                          savePreferences.onToggle(checked === true)
                        }
                      />
                      <label
                        htmlFor="save-preferences"
                        className="text-sm text-muted-foreground cursor-pointer"
                      >
                        {t("generate.saveSelection")}
                      </label>
                    </div>
                  )}
                </div>
                <div ref={submitRef} className="sticky bottom-0 left-0 right-0">
                  <SubmitCard
                    isLoading={isPending}
                    isSuccess={isSuccess}
                    sticky
                  />
                </div>
              </div>
            );
          })()}
        </form>
        {import.meta.env.DEV && (
          <DevTool control={form.control} placement="top-right" />
        )}
      </FormProvider>
    </>
  );
}

export default AppFormContainer;
